import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from "@auth0/auth0-react";

const RootRedirect = () => {
    const { user, isAuthenticated, isLoading } = useAuth0();
    const navigate = useNavigate();

    useEffect(() => {
        // Wait for Auth0 to finish loading
        if (isLoading) {
            return;
        }

        // If not authenticated, ProtectedRoute will handle redirect to login
        if (!isAuthenticated) {
            return;
        }

        // Check if user has roles
        const hasRoles = user && user['/roles'] && user['/roles'].length > 0;

        if (hasRoles) {
            // User with roles → redirect to dashboard
            navigate('/dashboard', { replace: true });
        } else {
            // User without roles → redirect to dashboard
            navigate('/dashboard', { replace: true });
        }
    }, [isLoading, isAuthenticated, user, navigate]);

    // Show loading spinner while Auth0 is loading
    if (isLoading) {
        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                flexDirection: 'column'
            }}>
                <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                    <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-3 text-muted">Loading...</p>
            </div>
        );
    }

    // Show nothing while redirecting (brief moment)
    return null;
};

export default RootRedirect;
